import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "form-group form-check" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 1,
  type: "button",
  class: "btn btn-primary btn-lg",
  disabled: ""
}
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = {
  class: "col-md-4 col-sm-6",
  style: {"margin-bottom":"20px"}
}
const _hoisted_13 = { class: "card bg-light" }
const _hoisted_14 = { class: "card-header" }
const _hoisted_15 = { class: "card-body" }
const _hoisted_16 = { class: "card-text" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 1,
  class: "container"
}

import { ref, computed, onMounted, watch } from 'vue'
    import { useRoute, useRouter } from 'vue-router'

    import ValidationError from '@common/Components/ValidationError.vue'
    import { useOrganizationAdminCandidatesQueryV1 } from '@Organizations/Users/queries-vue-composables'
    import
        {
            useCreateUserCommandV1,
            useAssignOrganizationAdminRoleCommandV1
        } from '@Organizations/Users/commands-vue-composables'

    // ----------------------------------
    // routing
    // ----------------------------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateOrganizationAdminPage',
  setup(__props) {

    const route = useRoute()
    const router = useRouter()

    const tid = computed(() => Number(route.params.tid))

    // ----------------------------------
    // local state
    // ----------------------------------

    const email = ref('')
    const firstName = ref('')
    const lastName = ref('')
    const password = ref('')
    const passwordConfirmation = ref('')
    const setInitialPassword = ref(false)

    // ----------------------------------
    // validation
    // ----------------------------------

    const passwordConfirmationInvalid = computed(() =>
    {
        if (!setInitialPassword.value) return false
        return !!passwordConfirmation.value && passwordConfirmation.value !== password.value
    })

    // ----------------------------------
    // queries
    // ----------------------------------

    const {
        runOrganizationAdminCandidatesQueryV1,
        modelOrganizationAdminCandidatesQueryV1
    } = useOrganizationAdminCandidatesQueryV1(tid)

    const users = computed(
        () => modelOrganizationAdminCandidatesQueryV1.value?.Users ?? []
    )

    // ----------------------------------
    // create user command
    // ----------------------------------

    const {
        invokeCreateUserCommandV1,
        invokingCreateUserCommandV1,
        succeedCreateUserCommandV1,
        validationErrors,
        errorCreateUserCommandV1
    } = useCreateUserCommandV1(
        '0',
        tid,
        email,
        firstName,
        lastName,
        false,
        true,
        false,
        false,
        setInitialPassword,
        password
    )

    const {
        invokeAssignOrganizationAdminRoleCommandV1,
        succeedAssignOrganizationAdminRoleCommandV1
    } = useAssignOrganizationAdminRoleCommandV1()


    onMounted(() =>
    {
        document.title = 'Organization admin setup'
        runOrganizationAdminCandidatesQueryV1()
    })

    function handleCreateUserCommandV1()
    {
        if (passwordConfirmationInvalid.value) return
        invokeCreateUserCommandV1()
    }

    function handleAssignOrganizationAdminRoleCommandV1(user: any)
    {
        if (window.confirm(`Do you really want to assign Organization Admin role for ${user.Email}?`))
        {
            invokeAssignOrganizationAdminRoleCommandV1({id: user.Email})
        }
    }

    // ----------------------------------
    // command outcomes
    // ----------------------------------

    watch(succeedAssignOrganizationAdminRoleCommandV1, (ok) =>
    {
        if (ok)
        {
            router.push('/admin/organizations/manage')
        }
    })

    watch(errorCreateUserCommandV1, (err) => 
    {
        if (err) {
            alert(err)
        }
    })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _cache[24] || (_cache[24] = _createStaticVNode("<div class=\"container\"><div class=\"row\"><div class=\"col-lg-7\"><h1 style=\"font-size:2em;font-weight:300;color:#33475b;margin-top:20px;\">Organization admin setup</h1></div></div></div><hr style=\"border-color:#bbb;margin:20px 0 30px;\">", 2)),
    (!_unref(succeedCreateUserCommandV1))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[17] || (_cache[17] = _createElementVNode("strong", null, "Create a new organization admin", -1 /* CACHED */)),
          _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_2, [
            _cache[6] || (_cache[6] = _createElementVNode("label", { for: "Email" }, "Email:", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
              type: "email",
              class: "form-control",
              placeholder: "Work email of an admin"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, email.value]
            ]),
            _createVNode(ValidationError, {
              context: "Email",
              errors: _unref(validationErrors)
            }, null, 8 /* PROPS */, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _cache[7] || (_cache[7] = _createElementVNode("label", { for: "FirstName" }, "First name:", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((firstName).value = $event)),
              type: "text",
              class: "form-control",
              placeholder: "First name of an admin"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, firstName.value]
            ]),
            _createVNode(ValidationError, {
              context: "FirstName",
              errors: _unref(validationErrors)
            }, null, 8 /* PROPS */, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[8] || (_cache[8] = _createElementVNode("label", { for: "LastName" }, "Last name:", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((lastName).value = $event)),
              type: "text",
              class: "form-control",
              placeholder: "Last name of an admin"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, lastName.value]
            ]),
            _createVNode(ValidationError, {
              context: "LastName",
              errors: _unref(validationErrors)
            }, null, 8 /* PROPS */, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((setInitialPassword).value = $event)),
              type: "checkbox",
              class: "form-check-input",
              id: "setInitialPassword"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelCheckbox, setInitialPassword.value]
            ]),
            _cache[9] || (_cache[9] = _createElementVNode("label", {
              class: "form-check-label",
              for: "setInitialPassword"
            }, "Set initial password manually", -1 /* CACHED */))
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_6, [
              _cache[10] || (_cache[10] = _createElementVNode("label", { for: "Password" }, "Initial password:", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((password).value = $event)),
                type: "password",
                class: "form-control"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, password.value]
              ]),
              _createVNode(ValidationError, {
                context: "Password",
                errors: _unref(validationErrors)
              }, null, 8 /* PROPS */, ["errors"])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_7, [
              _cache[11] || (_cache[11] = _createElementVNode("label", { for: "PasswordConfirmation" }, "Initial password confirmation:", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((passwordConfirmation).value = $event)),
                type: "password",
                class: _normalizeClass(["form-control", { 'is-invalid': passwordConfirmationInvalid.value }])
              }, null, 2 /* CLASS */), [
                [_vModelText, passwordConfirmation.value]
              ]),
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "invalid-feedback" }, "Initial password confirmation doesn't match", -1 /* CACHED */))
            ], 512 /* NEED_PATCH */), [
              [_vShow, password.value]
            ])
          ], 512 /* NEED_PATCH */), [
            [_vShow, setInitialPassword.value]
          ]),
          (!_unref(invokingCreateUserCommandV1))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: handleCreateUserCommandV1,
                type: "button",
                class: "btn btn-primary btn-lg",
                disabled: passwordConfirmationInvalid.value
              }, "Create", 8 /* PROPS */, _hoisted_8))
            : (_openBlock(), _createElementBlock("button", _hoisted_9, "Creating...")),
          _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          (users.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _cache[13] || (_cache[13] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
                _cache[14] || (_cache[14] = _createElementVNode("strong", null, "Set existing user as organization admin", -1 /* CACHED */)),
                _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (u) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, _toDisplayString(u.FirstName) + " " + _toDisplayString(u.LastName), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("p", _hoisted_16, _toDisplayString(u.Email), 1 /* TEXT */),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (handleAssignOrganizationAdminRoleCommandV1(u)),
                            class: "btn btn-link"
                          }, "Set as admin", 8 /* PROPS */, _hoisted_17)
                        ])
                      ])
                    ]))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _cache[22] || (_cache[22] = _createElementVNode("h1", null, "Congratulation!", -1 /* CACHED */)),
          _createElementVNode("h3", null, "Organization admin account was created and password was sent on email " + _toDisplayString(email.value), 1 /* TEXT */),
          _cache[23] || (_cache[23] = _createElementVNode("a", {
            class: "btn btn-primary btn-lg",
            href: "/#/admin/organizations/manage",
            role: "button"
          }, "Manage organizations", -1 /* CACHED */))
        ]))
  ]))
}
}

})